import type { QueryClient } from "@tanstack/react-query";

export const invalidateDeviceQueries = (client: QueryClient) =>
  Promise.all(
    ["admin-device-list", "quotation-device-list", "device-detail", "device-order-list", "device-from-partner", "device-quotation-list"]
      .map((key) => client.invalidateQueries({ queryKey: [key] }))
  );

export const deviceErrorMessage = (error: unknown): string =>
  error instanceof Error ? error.message : "기종 정보를 처리하지 못했습니다.";
